import {Component, inject, Ref, ref} from 'vue'

const panelComponentMap = ref(new Map<number, Component>)
const slideInShownMap = ref(new Map<number, boolean>)

const useSlideIn = () => {


    const panelId = inject('panelId') as Ref<number>

    const addComponentToMap = (component: () => Component) => {
        panelComponentMap.value.set(panelId?.value, component)
    }

    const setComponentForPanel = (component: Component) => {
        panelComponentMap.value.set(panelId?.value, component)
    }

    const removeComponentFromMap = () => {
        panelComponentMap.value.delete(panelId?.value)
    }

    const getComponent = () => {
        return panelComponentMap.value.get(panelId?.value)
    }

    const closeSlideIn = () => {
        removeComponentFromMap()
        slideInShownMap.value.set(panelId?.value, false)
    }


    const showSlideIn = (component?: any) => {
        if (!slideInShownMap.value.get(panelId?.value)) {
            slideInShownMap.value.set(panelId?.value, true)
            addComponentToMap(component)
            setComponentForPanel(component)
        }
    }

    return {setComponentForPanel, addComponentToMap, showSlideIn, getComponent, closeSlideIn}
}


export default useSlideIn
